<template>
  <div>
    <p class="title is-6">
      Custom Layout
      <b-button
        type="is-info"
        size="is-small"
        @click="
          toggle_custom_layout_cl_drawer = !toggle_custom_layout_cl_drawer
        "
        >Toggle Clipart Drawer</b-button
      >
    </p>
    <multi-clipart-selector
      v-show="toggle_custom_layout_cl_drawer"
      @input="addClipartRowFromDrawer"
    ></multi-clipart-selector>

    <div class="columns is-multiline">
      <div v-if="custom_layout.objects.length" class="column is-12">
        <p class="title is-5">
          Current Layer Settings (Layer {{ current_cl_row_index + 1 }})
        </p>
        <set-custom-layout-table-row
          :key="`CURRENT_CL_ROW_COMPONENT`"
          v-model="custom_layout.objects[current_cl_row_index]"
          :question_type="question_type"
        ></set-custom-layout-table-row>
      </div>

      <div style="display: flex" class="column is-12">
        <div
          :style="
            `width: ${custom_layout.allowed_width +
              10}px;height: 600px;position:relative;overflow-x: scroll;`
          "
        >
          <div
            ref="custom_layout_outer_box"
            :style="
              `width: ${custom_layout.allowed_width}px;height:${custom_layout.allowed_height}px;position:absolute;border: 1px solid grey;box-sizing: content-box;`
            "
          >
            <vue-drag-resize
              v-for="(clo, clo_index) in customLayoutObjects"
              :key="`CLO_${clo_index}`"
              :parentLimitation="true"
              :isActive="current_cl_row_index == clo_index"
              :isDraggable="current_cl_row_index == clo_index"
              :isResizable="current_cl_row_index == clo_index"
              :z="current_cl_row_index == clo_index ? 9999 : 'auto'"
              @dragging="dragObject($event, clo_index)"
              @resizing="dragObject($event, clo_index)"
              :w="clo.width"
              :h="clo.height"
              :x="clo.left"
              :y="clo.top"
              :minh="10"
              :minw="10"
              :parentW="parseInt(custom_layout.allowed_width)"
              :parentH="parseInt(custom_layout.allowed_height)"
            >
              <!--Showing Sound Box-->
              <show-sound-box
                v-if="clo.type == 'SOUND-BOX'"
                :sound_box="clo.sound_box"
              ></show-sound-box>  
              
              <!--Showing Shapes for square/rectangle-->
              <show-shape
                v-if="clo.type == 'SHAPES'"
                :shape="clo.shapes"
              ></show-shape>

              <!--Showing Shapes-II-->
              <show-shapes
                v-if="clo.type == 'SHAPES-II' && clo.shapes_grid"
                :is_selectable="
                  clo.shapes_grid && clo.shapes_grid.is_selectable
                "
                :shapes="clo.shapes_grid && clo.shapes_grid"
              ></show-shapes>

              <!--Showhing Hline-->
              <show-line v-if="clo.type == 'HLINE'" :clo="clo" />

              <!--Showing Input-->
              <b-input
                :class="
                  `clinp ${
                    clo.input_type && clo.input_type == 'SM' ? 'is-sm' : ''
                  }`
                "
                :size="$common.customLayoutInputSize(clo.input_size)"
                v-if="clo.type == 'INPUT'"
                :value="clo.answer"
                readonly
              ></b-input>
              <!--If Clock-->
              <show-clock v-if="clo.type == 'CLOCK'" :clock="clo.clock" />

              <!--If PROTRACTOR-->
              <show-protractor
                v-if="clo.type == 'PROTRACTOR'"
                :protractor="clo.protractor"
              />
              <!--If Ruler-->
              <show-ruler v-if="clo.type == 'RULER'" :ruler="clo.ruler" />
              <!--If Multi-chars-->
              <show-multi-chars
                v-if="clo.type == 'MULTI-CHARS'"
                :multi_chars="clo.multi_chars"
                is_show_answer
              />
              <!--Showing Picture Library Image-->
              <show-image
                v-if="
                  clo.type == 'IMAGE' &&
                    clo.picture_type == 'P' &&
                    clo.picture_library
                "
                :src="showImagePath(clo_index)"
                :width="clo.width"
                :height="clo.height"
              />
              <!--Showing Clipart Image-->
              <show-image
                v-if="
                  clo.type == 'IMAGE' && clo.picture_type == 'C' && clo.clipart
                "
                :src="clo.clipart.file"
                :width="clo.width"
                :height="clo.height"
              />
              <!--Showing Clipart Layer-->
              <show-clipart-layer
                v-if="clo.type == 'IMAGE' && clo.picture_type == 'CL'"
                :layers="clo.layers"
              ></show-clipart-layer>
              <!--Showing Text-->
              <div
                v-if="clo.type == 'TEXT'"
                :style="
                  `white-space:pre-wrap;font-size:${
                    clo.font_size
                  }px;font-weight:${clo.is_bold ? 'bold' : 'normal'}${
                    clo.text_align ? `text-align:${clo.text_align}` : ''
                  }`
                "
              >
                {{ clo.text }}
              </div>
              <!--Showing Question Text-->
              <div
                v-if="clo.type == 'QTEXT'"
                class="title is-4"
                style="white-space: pre-wrap"
              >
                {{ clo.text }}
              </div>
              <!--Showing HTML Text-->
              <quill-view
                v-if="clo.type == 'HTMLTEXT'"
                :data="clo.text"
              ></quill-view>

              <p></p>
            </vue-drag-resize>
          </div>
        </div>
        <!--Summary Tables-->
        <div
          :style="`width: calc(100% - ${custom_layout.allowed_width + 10}px);`"
        >
          <div class="column is-12">
            <div class="columns">
              <div class="column is-4">
                <b-button
                  size="is-small"
                  type="is-info"
                  @click="addCustomLayoutRow()"
                  >Add Row</b-button
                >
              </div>
              <div class="column is-4">
                <b-field horizontal label="Width">
                  <b-numberinput
                    size="is-small"
                    :controls="false"
                    v-model="custom_layout.allowed_width"
                  ></b-numberinput>
                </b-field>
              </div>
              <div class="column is-4">
                <b-field horizontal label="Height">
                  <b-numberinput
                    size="is-small"
                    :controls="false"
                    v-model="custom_layout.allowed_height"
                  ></b-numberinput>
                </b-field>
              </div>
            </div>
          </div>
          <table class="table is-bordered is-fullwidth">
            <thead>
              <tr>
                <th>Type</th>
                <th>Remove</th>
              </tr>
            </thead>
            <tbody>
              <tr
                v-for="(object, object_i) in custom_layout.objects"
                :key="`CL_ROW_${object_i}`"
              >
                <td
                  :class="object_i == current_cl_row_index ? 'clicked-row' : ''"
                  @click="setCurrentCLRow(object_i)"
                >
                  Layer {{ object_i + 1 }} - {{ object.type }}
                </td>
                <td>
                  <div class="buttons">
                    <b-button
                      size="is-small"
                      type="is-warning"
                      @click="copyCLRow(object)"
                      >Copy</b-button
                    >
                    <b-button
                      size="is-small"
                      icon-left="close"
                      type="is-danger"
                      @click="removeCLRow(object_i)"
                    ></b-button>
                  </div>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { mapGetters } from "vuex";
import ShowImage from "@/components/General/ShowImage";
import MultiClipartSelector from "@/components/Question/MultiClipartSelector";
import ShowClipartLayer from "@/components/Question/ShowClipartLayer";
import SetCustomLayoutTableRow from "@/components/Question/CustomLayout/SetCustomLayoutTableRow";
import ShowClock from "@/components/Question/Clock/ShowClock";
import ShowShapes from "@/components/Question/Shapes/ShowShapes";
import ShowProtractor from "@/components/Question/Protractor/ShowProtractor";
import ShowRuler from "@/components/Question/Ruler/ShowRuler";
import QuillView from "@/components/Editor/QuillView";
import ShowMultiChars from "@/components/Question/MultiChars/ShowMultiChars";
import ShowLine from "@/components/Question/CustomLayout/Line/ShowLine";
import ShowShape from "@/components/Question/CustomLayout/Shapes/ShowShape";
import ShowSoundBox from "@/components/Question/CustomLayout/CustomSound/ShowSoundBox";
import {
  defaultCustomLayoutValue,
  returnNewCLOLayer,
} from "@/components/Question/CustomLayout/utils";
import { getCSSFromStyles } from "@/components/Common/StyleEditor/utils";

export default {
  name: "set-custom-layout",
  components: {
    ShowImage,
    MultiClipartSelector,
    ShowClipartLayer,
    SetCustomLayoutTableRow,
    QuillView,
    ShowClock,
    ShowProtractor,
    ShowRuler,
    ShowMultiChars,
    ShowLine,
    ShowShape,
    ShowShapes,
    ShowSoundBox
  },
  props: {
    value: {
      type: Object,
    },
    question_type: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      toggle_custom_layout_cl_drawer: false,
      custom_layout: this.value ? this.value : defaultCustomLayoutValue(),
      current_cl_row_index: 0,
    };
  },
  methods: {
    shapesStyles(clo) {
      let styles = {};
      styles = getCSSFromStyles(clo.shapes.shape_styles);
      return styles;
    },
    setCurrentCLRow(object_i) {
      this.current_cl_row_index = object_i;
    },
    removeCLRow(index) {
      if (this.current_cl_row_index == index) {
        return this.$buefy.toast.open({
          message: "Cannot delete row currently selected row",
          type: "is-danger",
        });
      }

      this.current_cl_row_index = 0;
      this.$set(
        this.custom_layout,
        "objects",
        [...this.custom_layout.objects].filter((r, i) => i !== index)
      );
    },
    copyCLRow(object) {
      let copied_object = JSON.parse(JSON.stringify(object));
      copied_object.top = 0;
      copied_object.left = 0;
      this.custom_layout.objects.push(copied_object);

      this.$buefy.toast.open({
        message: "Row copied successfully",
        type: "is-success",
      });
    },
    addClipartRowFromDrawer(clipart_obj) {
      let clo_row = returnNewCLOLayer();
      clo_row["type"] = "IMAGE";
      clo_row["picture_type"] = "C";
      clo_row["clipart"] = clipart_obj.clipart;
      clo_row["width"] = clipart_obj.width;
      clo_row["height"] = clipart_obj.height;
      this.custom_layout.objects.push(clo_row);
      this.$buefy.toast.open({
        message: "Added clipart to custom layout row",
        type: "is-success",
      });
    },
    addCustomLayoutRow() {
      this.custom_layout.objects.push(returnNewCLOLayer());
    },
    dragObject(newRect, i) {
      const current_obj = Object.assign({}, this.custom_layout.objects[i]);
      current_obj.top = newRect.top;
      current_obj.left = newRect.left;
      current_obj.width = newRect.width;
      current_obj.height = newRect.height;
      this.$set(this.custom_layout.objects, i, current_obj);
    },
    showImagePath(i) {
      const current_pl_id = this.custom_layout.objects[i].picture_library;
      return this.plPath(current_pl_id);
    },
    plPath(id) {
      const current_pl = this.fetchPictureLibraries.find(
        (obj) => obj._id == id
      );
      return current_pl ? current_pl.file : null;
    },
    checkNested(obj /*, level1, level2, ... levelN*/) {
      var args = Array.prototype.slice.call(arguments, 1);
      for (var i = 0; i < args.length; i++) {
        // eslint-disable-next-line no-prototype-builtins
        if (!obj || !obj.hasOwnProperty(args[i])) {
          return false;
        }
        obj = obj[args[i]];
      }
      return true;
    },
  },
  computed: {
    ...mapGetters(["fetchPictureLibraries"]),
    customLayoutObjects() {
      console.log(this.custom_layout.objects);
      return this.custom_layout.objects.filter((row) => row.type);
    },
  },
  watch: {
    custom_layout: {
      handler: function(new_val) {
        // updating some keys
        this.custom_layout.parent_height = new_val.allowed_height;
        this.custom_layout.parent_width = new_val.allowed_width;
        this.$emit("input", new_val);
      },
      deep: true,
    },
    value: function(new_val) {
      this.custom_layout = new_val;
    },
  },
};
</script>
<style>
.clicked-row {
  border: 2px solid #000;
}
</style>
